/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Ai_ConfirmedInputs */

const cs_locale_ai_confirmed = /** @type {(inputs: Locale_Ai_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Překlad zkontrolován`)
};

const en_locale_ai_confirmed = /** @type {(inputs: Locale_Ai_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation reviewed`)
};

/**
* | output |
* | --- |
* | "Translation reviewed" |
*
* @param {Locale_Ai_ConfirmedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const locale_ai_confirmed = /** @type {((inputs?: Locale_Ai_ConfirmedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Ai_ConfirmedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locale_ai_confirmed(inputs)
	return cs_locale_ai_confirmed(inputs)
});